import { Component, OnInit, Input, ChangeDetectorRef, AfterViewInit, Output } from '@angular/core';
import { DataProperties } from 'src/app/core/models/data-properties.model';
import { Subject } from 'rxjs';
import { LoaderMessagingService } from 'src/app/core/services/messaging/loader-messaging.service';
import {
  orderDataProperties,
  PROCESSING_STATUS_1,
  PROCESSING_STATUS_2,
  PROCESSING_STATUS_3,
  PROCESSING_STATUS_4,
  PROCESSING_STATUS_5,
  PROCESSING_STATUS_6,
  PROCESSING_STATUS_7,
} from 'src/app/core/constants/configuration/order-constants.config';
import { takeUntil } from 'rxjs/operators';
import { faPencilAlt, faSort, faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { Router } from '@angular/router';
import { ORDERS_PATH, ORDER_DEPOSIT_PATH, ORDER_CURRICULUM_FEE_PATH, OLD_ORDERS_PATH } from 'src/app/core/constants/routes.constant';
import { EventEmitter } from '@angular/core';
import { DESC, ASC } from 'src/app/core/constants/configuration/common.constant';
import SortUtil from 'src/app/shared/components/utils/sort-utils/sort-util';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent implements OnInit {

  @Input() items: any[] = [];
  @Input() sortedBy: string;
  @Input() sortOrder: string;
  @Input() orderStatus: any[] = [];
  @Output() toggleSortOnClick : EventEmitter<any> = new EventEmitter();
  dataProperties: DataProperties[];
  headersLength: number;
  isLoading: boolean = false;
  unsubscribe: Subject<any> = new Subject();
  faPencilAlt = faPencilAlt;
  faSortDefaultIcon = faSort;
  faSortIcon = faSort;
  faSort = faSort;
  updatedSortOrder: string;

  constructor(
    private loaderMessagingService: LoaderMessagingService,
    private router: Router,
  ) {
    this.subscribeToLoaderMessagingService();
  }

  // How can I bind the updated value of parent's field to child without this loc?
  ngOnChanges() {
    this.updatedSortOrder = this.sortOrder;
    this.faSortIcon = SortUtil.toggleSortIcon(this.updatedSortOrder);
  }

  ngOnInit() {
    this.dataProperties = orderDataProperties;
    this.headersLength = this.dataProperties.length;
  }

  onLinkClick(item: any, $event: any, id: string): void {
    if(item.code.includes("-DEPOSIT")) {
      this.router.navigate([ORDER_DEPOSIT_PATH, id]);
    } else if(item.code.includes("-FEE")) {
      this.router.navigate([ORDER_CURRICULUM_FEE_PATH, id]);
    } else if(item.syCode == "2019-2020"){
      this.router.navigate([OLD_ORDERS_PATH, id]);
    } else {
      this.router.navigate([ORDERS_PATH, id]);
    }
  }

  private subscribeToLoaderMessagingService(): void {
    this.loaderMessagingService.listLoader$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(show => setTimeout(() => (this.isLoading = show)));
  }

  getStatusClass(statusName: string): string {
    let currentStatus = this.orderStatus.find(status => status.name === statusName);
    if (currentStatus) {
      switch (currentStatus.code) {
        case PROCESSING_STATUS_1: return "approved status"
        case PROCESSING_STATUS_2: return "processing status"
        case PROCESSING_STATUS_3: return "pre-completed status"
        case PROCESSING_STATUS_4: return "completed status"
        case PROCESSING_STATUS_5: return "canceled status"
        case PROCESSING_STATUS_6: return "refunded status"
        case PROCESSING_STATUS_7: return "adjusted status"
        default: return "status"
      }
    }
  }

  toggleSort(property: string) {
    if (property === this.sortedBy) {
      if (this.sortOrder === DESC) {
        this.faSort = faSortUp;
        this.sortOrder = ASC;
      } else if (this.sortOrder === ASC) {
        this.faSort = faSortDown;
        this.sortOrder = DESC;
      } else if (this.faSort === faSortDown) {
        this.faSort = faSort;
        this.sortedBy = "";
        this.sortOrder = ASC;
      }
    } else {
      this.sortedBy = property;
      if (!this.sortOrder && property === 'name') {
        this.faSort =  faSortDown;
        this.sortOrder = DESC;
      } else {
        this.faSort =  faSortUp;
        this.sortOrder = ASC;
      }
    }

    this.toggleSortOnClick.emit({ sortedBy: this.sortedBy, sortOrder: this.sortOrder });
  }
}
